import Nav from '../components/Nav';
import heroimageS from "../assets/images/small/Nadine&JP-97.webp";
import heroimageL from "../assets/images/big/Nadine&JP-97.jpg"

import {
  Box,
  Typography,
  Grid,
  Container,
} from '@mui/material';
import Hero from '../components/Hero';
import { Circle } from '../components/Circle';


export default function Details() {
  return (
    <>
      <Nav />
      <Hero name="DETAILS" imageS={heroimageS} imageL={heroimageL} />
      <Box className="wedding-details">
        <Container className="details" maxWidth="lg">
          <Box width={{md: "50%"}} pt="4em" pb="10em" justifyContent="center" textAlign="center" mx="auto">
            <Typography className="title">The Church Ceremony</Typography>
            <Typography className="name" pb="0.25em">San Agustin Church</Typography>
            <Typography className="location" pb="0.75em">General Luna St, Manila, 1002 Metro Manila, Philippines</Typography>
            <Typography className="entourage-time">We kindly request the entourage to be at the church venue at 2:30pm for the procession line-up.</Typography>
          </Box>
          <Box pb="8em" justifyContent="center" textAlign="center" mx="auto">
            <Typography className="title">COCKTAILS & RECEPTION</Typography>
            <Typography className="name" pb="0.25em">Oasis Manila - Pavillion</Typography>
            <Typography className="location">169 Aurora Blvd, New Manila, San Juan,</Typography>
            <Typography className="location" pb="0.75em">1500 Metro Manila, Philippines</Typography>
            <Typography className="time">Doors open at 6:00PM</Typography>
          </Box>
        </Container>
      </Box>
      <Container className="details" maxWidth="lg">
        <Grid
          container
          rowSpacing={{ xs:5, lg: 10}}
          pt="5em" pb="5em"
        >
          <Grid item xs={12} md={6}>
            <Typography className="col1" width={{lg: "50%"}}>Parking & Transportation</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box className="paragraph">
              <Typography>San Agustin Church (Church Venue) has a limited parking space so we recommend heading there earlier (at least 30 minutes before procession time) to secure a spot. Meanwhile, Oasis Manila (Reception Venue) has ample of parking space.</Typography>
              <Typography>It’s 30-35 minute drive from San Agustin Church to Oasis Manila, so it’s best to drive or get a grab to get from the church to the reception venue. But do keep in mind of the notorious Manila traffic.</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className="col1">GUEST ATTIRE</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box className="paragraph">
              <Typography className="col2"><b>Ladies:</b> Your best formal wear in soft neutral or muted earth tone colors (soft greens/sage, creamy neutrals, dusty blush, soft blues and grey blues).  Below are some colours inspirations. No white, black or vibrant/bold color dresses please.</Typography>
              <Grid
                container
                justifyContent={{xs: "flex-start", md: "center"}}
                flexWrap="wrap"
                spacing={{xs: 0, md: 1}}
              >
                <Grid item><Circle color="#BCBCC7"/></Grid>
                <Grid item><Circle color="#CED5DC"/></Grid>
                <Grid item><Circle color="#A19B9B"/></Grid>
                <Grid item><Circle color="#8C8F86"/></Grid>
                <Grid item><Circle color="#8D998D"/></Grid>
                <Grid item><Circle color="#E6D5CB"/></Grid>
                <Grid item><Circle color="#DDCDB9"/></Grid>
                <Grid item><Circle color="#D3B09D"/></Grid>
                <Grid item><Circle color="#E1D3D0"/></Grid>
                <Grid item><Circle color="#D0C5C3"/></Grid>
              </Grid>
              <Typography className="col2" pt="2em"><b>Gentlemen:</b> Your dapper suit that includes blazer and tie.</Typography>
              <Typography className="col2">Strictly, no denims, jeans, sneakers/trainers, slippers or flip-flops.</Typography>
              <Typography className="italic">If you’re part of the entourage, head over to the ENTOURAGE Page for more information.</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className="col1">GIFTS</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className="col2">Your presence at our wedding means the world to us, but if you insist on spoiling us, a little help to our honeymoon as enveloped gifts will be gladly appreciated!</Typography>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}